import useWorkspaceStore from '@/stores/WorkspaceStore';

import { FACE_CREAM_WORKSPACE_ALIAS } from './config';

export const useFaceCream = () => {
  const currWorkspace = useWorkspaceStore((state) => state.currWorkspace);
  return currWorkspace?.alias === FACE_CREAM_WORKSPACE_ALIAS;
};
